export function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

export function addMarker(info, dataType, map, drawCircle, circleR, icon, showName, trans, fgColor, intensity) {
  var val = info[dataType] == '--' ? 0 : info[dataType]
  if (!val) {
    val = '--'
  } else {
    val = Math.round(val)
  }
  if (showName == false) {
    var text = val
  } else {
    var text = info.station + ':' + val
  }

  if (info.index) {
    text = info.index + ':' + text
  }

  if (!icon) {
    icon = ''
  }

  if(showName) {
    icon = icon + info.station_level
  }

  function getByteLen(str) {
    var len = 0;
    for (var i = 0; i < str.length; i++) {
      var ch = str.charCodeAt(i);
      if (ch >= 0 && ch <= 128) {
        len += 1;
      } else {
        len += 2;
      }
    }
    return len;
  }

  var width = getByteLen(text) * 6.5 - 8;
  if (width > 10) {
    width = width + 60
  } else {
    width = 39
  }
  var arrow_left = width / 2 - 5

  var transbg = intensity.bgcolor.getColor(val)
  var fgcolor = intensity.fgcolor.getColor(val)

  var htm = "<div style='position: absolute;z-index:100;border-radius: 5px;border: 2px solid " + "black" + "; color: white;transform:translate(-50%,-50%);bottom:5px;width:" + width + "px' >" +
    "<div style='background-color:" + transbg + ";text-align: center; font-size: 12px; padding: 0px 1px; margin: 0px; height: 20px; border-radius: 2px;color:" + fgcolor + "'>" + icon + "<span style='display:inline-block;margin-left: 2px;" + ";color:" + fgcolor + "'>" + text + "</span></div>" +
    "<div class='arrow'" +
    " style=\"background: url('http://iot.novaecs.com/f/v1/img/bdmap/label.png') 0px 0px no-repeat; position: absolute; width:6px; height: 15px; top: 22px; left: " + arrow_left + "px; overflow: hidden;\">" +
    "</div></div>"

  var p = new BMap.Point(info.lng, info.lat)
  // console.log(p)
  var marker = new BMapLib.RichMarker(htm, p, {
    zIndex: 100
  });
  // marker.setZIndex(10)
  if (drawCircle) {
    var circleMarker = new BMap.Circle(p, circleR, {
      fillOpacity: 0.001,
      strokeWeight: 3,
      strokeColor: transbg
    })
    map.addOverlay(circleMarker);
    marker.circleMarker = circleMarker
  }

  marker.info = info
  map.addOverlay(marker);
  return marker
}



// WEBPACK FOOTER //
// ./src/utils/utils.js